import { render } from "./BIM_LibraryMarket.vue?vue&type=template&id=85105938"
import script from "./BIM_LibraryMarket.vue?vue&type=script&lang=js"
export * from "./BIM_LibraryMarket.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__